import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { SponsorPayPalBuyNow, PayPalNoticeModal, CheckFormModal, enableOptionGroupValidation, RegistrationSection, sponsorInfoValidation, phoneNumberMask, sponsorshipLevelValidation } from './shared'
import MaskedInput, { conformToMask } from 'react-text-mask'
import { camelCase } from 'lodash'
import axios from 'axios'
import * as Yup from 'yup'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export class SponsorForm extends React.Component {
  state = {
    checkFormModalOn: false,
    paypalNoticeOn: false,
    dfsRequirementsModalOn: false,
    cart: {
      id: null,
      itemCount: 0,
      items: [],
      totalAmount: 0
    },
    currentSponsorship: {
      id: '',
      cost: null,
      name: ''
    },
    sponsorshipOptions: [],
    event: null,
    co: null
  }

  componentDidMount = () => {
    enableOptionGroupValidation()
    this.getCart()
  }

  sponsorFormInitialValues = {
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phone: ''
  }

  getCart = () => {
    axios.get(`${window.location.origin}${this.props.endpoint}`)
      .then(res => {
        const newInitialValues = { ...this.sponsorFormInitialValues }
        newInitialValues.phone = conformToMask(newInitialValues.phone, phoneNumberMask).conformedValue

        for (const [key, value] of Object.entries(newInitialValues)) {
          if (value == null) newInitialValues[key] = ''
        }

        if (res.data.event.sections.length > 0) {
          newInitialValues.options = {}
          res.data.event.sections.map(item => {
            if (item.sponsor && item.sectionType == 'option_group') {
              newInitialValues.options[camelCase(item.name)] = ''
            }
          })
        }

        this.setState({ cart: res.data.cart })
        this.setState({ event: res.data.event })
        this.setState({ co: res.data.co })
        this.setState({ initialValues: newInitialValues })
        this.sponsorshipDropdown.focus()
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  setSponsorship = (form) => {
    if (form.dirty && form.values.sponsorshipLevel != this.state.currentSponsorship.id.toString()) {
      axios.put(`${window.location.origin}${this.props.endpoint}`, { eventCode: this.state.event.eventCode, sponsorshipId: form.values.sponsorshipLevel })
        .then(res => {
          if ('id' in res.data) {
            this.setState({ currentSponsorship: res.data })
          } else {
            this.setState({ currentSponsorship: { id: '', cost: null, name: '' } })
          }
          console.log(res.data)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  postItem = (values, form) => {
    axios.post(`${window.location.origin}${this.props.endpoint}`, { data: values })
      .then(res => {
        this.setState({ cart: res.data })
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
    form.setSubmitting(false)

    let newOptionValues = null
    if (values.options) {
      newOptionValues = { ...values.options }
      Object.keys(newOptionValues).forEach(key => {
        newOptionValues[key] = ''
      })
    }

    form.resetForm({
      firstName: '',
      lastName: '',
      company: values.company,
      email: '',
      phone: values.phone
    })
    this.firstNameInput.focus()
  }

  deleteItem = (itemId) => {
    axios.delete(`${window.location.origin}${this.props.endpoint}/${itemId}`)
      .then(res => {
        this.setState({ cart: res.data })
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  toggleCheckFormModal = () => {
    this.setState({
      checkFormModalOn: !this.state.checkFormModalOn
    })
  }

  toggleDfsRequirementsModal = (e) => {
    e.preventDefault()
    this.setState({
      dfsRequirementsModalOn: !this.state.dfsRequirementsModalOn
    })
  }

  openCheckForm = () => {
    this.state.co && window.open(this.state.co.cform, '_blank')
  }

  togglePayPalNotice = () => {
    this.setState({
      paypalNoticeOn: !this.state.paypalNoticeOn
    })
  }

  formValidation = () => {
    let optionsValidation = {}
    const terminal = 'sponsor'

    this.state.event.sections.map(section => {
      if (section.sectionType == 'option_group' && section[terminal]) {
        optionsValidation[camelCase(section.name)] = Yup.string().optionGroup(section, terminal)
      }
    })

    let options = Yup.object().shape(optionsValidation)

    return Yup.object().shape({ ...sponsorInfoValidation, options })
  }

  render () {
    return (
      <React.Fragment>
        {this.state.event && this.state.event.sponsorships.length > 0 &&
        <Formik
          initialValues={{ sponsorshipLevel: this.state.currentSponsorship.id }}
          validationSchema={sponsorshipLevelValidation}
          render={(form) => {
            return (
              <Form className='registration' onChange={this.setSponsorship(form)} noValidate>
                <section>
                  <div className='field'>
                    <label htmlFor='sponsorshipLevel'>Sponsorship Level</label>
                    <Field
                      name='sponsorshipLevel'
                      component='select'
                      id='sponsorshipLevel'
                      innerRef={(input) => { this.sponsorshipDropdown = input }}
                    >
                      <option value=''>-- Please Select --</option>
                      {this.state.event.sponsorships.map(item => (
                        <option key={item.id} value={item.id}>{item.name} - ${item.cost.toLocaleString()}</option>
                      ))}
                    </Field>
                    <ErrorMessage component='small' name='sponsorshipLevel' className='errors' />
                  </div>
                </section>
              </Form>
            )
          }}
        />
        }

        {this.state.initialValues &&
        <Formik
          initialValues={this.state.initialValues}
          validationSchema={this.formValidation}
          onSubmit={this.postItem}
          validateOnBlur={false}
          render={(form) => {
            return (
              <Form className='registration' noValidate>

                <section>
                  <div className='field'>
                    <label htmlFor='firstName'>First Name</label>
                    <Field
                      type='firstName'
                      name='firstName'
                      id='firstName'
                      innerRef={(input) => { this.firstNameInput = input }}
                    />
                    <ErrorMessage component='small' name='firstName' className='errors' />
                  </div>
                  <div className='field'>
                    <label htmlFor='lastName'>Last Name</label>
                    <Field type='lastName' name='lastName' id='lastName' />
                    <ErrorMessage component='small' name='lastName' className='errors' />
                  </div>
                </section>

                <section>
                  <div className='field'>
                    <label htmlFor='company'>Company / Firm</label>
                    <Field name='company' type='text' id='company' />
                    <ErrorMessage component='small' name='company' className='errors' />
                  </div>
                </section>

                <section>
                  <div className='field'>
                    <label htmlFor='email'>Email Address</label>
                    <Field name='email' type='text' id='email' />
                    <ErrorMessage component='small' name='email' className='errors' />
                  </div>
                  <div className='field'>
                    <label htmlFor='phone'>Phone Number</label>
                    <Field
                      name='phone'
                      type='tel'
                      id='phone'
                      component={MaskedInput}
                      mask={phoneNumberMask}
                      placeholderChar={'\u2000'}
                      onChange={form.handleChange}
                      onBlur={form.handleBlur}
                      value={form.values.phone}
                    />
                    <ErrorMessage component='small' name='phone' className='errors' />
                  </div>
                </section>

                {this.state.event && this.state.event.sections.map(item => (
                  <RegistrationSection key={item.id} terminal='sponsor' section={item} form={form} toggleDfsRequirementsModal={this.toggleDfsRequirementsModal} />
                ))}

                <section>
                  <div className='field'>
                    <button type='submit' className='add-attendee' disabled={form.isSubmitting}>
                      Add Attendee
                    </button>
                  </div>
                </section>

              </Form>
            )
          }}
        />
        }

        <div className='side-bar'>

          <div className='cart'>
            <div className='cart-header'>
              <strong>Attendees: {this.state.cart.itemCount}</strong>
            </div>
            <ul className='cart-items'>
              {this.state.cart.items.map(item => (
                <CartItem key={item.id} item={item} onDelete={this.deleteItem} />
              ))}
            </ul>
            <div className='cart-total'>
              {this.state.currentSponsorship.cost &&
              <strong>Total Amount: ${this.state.currentSponsorship.cost.toLocaleString()}</strong>
              }
            </div>
          </div>

          {this.state.cart.items.length > 0 && this.state.currentSponsorship.id &&
          <React.Fragment>
            <div className='checkout'>
              <div className='checkout-header'>
                <strong>Checkout</strong>
              </div>
              <div className='checkout-body'>
                <p>Please select a method of payment below.</p>
                <p>You can pay by credit card by choosing PayPal.</p>
                <SponsorPayPalBuyNow
                  cart={this.state.cart}
                  sponsorship={this.state.currentSponsorship}
                  eventCode={this.state.event.code}
                  handleSubmit={this.togglePayPalNotice}
                  ppid={this.state.co.ppid}
                  ppurl={this.state.co.ppurl}
                  returnUrl={this.state.co.pp}
                />
                <CheckFormModal
                  on={this.state.checkFormModalOn}
                  toggle={this.toggleCheckFormModal}
                  openForm={this.openCheckForm}
                  completeRegistrationLink={this.state.co.ck}
                />
                <PayPalNoticeModal on={this.state.paypalNoticeOn} toggle={this.togglePayPalNotice} />
              </div>
            </div>
          </React.Fragment>
          }
        </div>

      </React.Fragment>
    )
  }
}

class CartItem extends React.Component {
  handleDelete = () => {
    this.props.onDelete(this.props.item.id)
  }

  render () {
    return (
      <li className='cart-item'>
        <strong>{this.props.item.data.firstName} {this.props.item.data.lastName}</strong>
        <span className='delete-button' onClick={this.handleDelete}><i /></span>
        <ul className='item-details'>
          <li className='item-description'>{this.props.item.event.name}</li>
        </ul>
      </li>
    )
  }
}
